import GlobalTheme from "../../../styles/global.theme";
import { DynamicTypography } from "./Typography";

export const CompanyTypography = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      fontSize: GlobalTheme.typography.h1.fontSize,
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
      color: GlobalTheme.palette.black.primary.main,
      fontWeight: `${GlobalTheme.typography.fontWeightLight}`,
      "@media (max-width: 320px)": {
        marginTop: "50px !important",
        fontWeight: `${GlobalTheme.typography.fontWeightLight}`,
        marginBottom: 0,
        fontSize: `${GlobalTheme.typography.h1.fontSize} !important`,
      },
      ...props.sx,
    }}
  />
);
export const CustomAddTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontWeight: "500",
      color: GlobalTheme.palette.purple.primary.main,
      padding: "20px",
      cursor: "pointer",
      textAlign: "left",
      width: "100%",
      "@media (max-width: 320px)": {
        marginLeft: "-20px",
      },
    }}
  />
);
export const AdditionalDetailTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      cursor: "pointer",
      textAlign: "left",
      width: "100%",
      fontSize: "16px",
      marginLeft: "20px",
      "@media (max-width: 320px)": {
        marginLeft: "5px",
      },
    }}
  />
);

export const AuthorisedAddTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontWeight: GlobalTheme.typography.fontWeightRegular,
      color: GlobalTheme.palette.purple.primary.main,
      cursor: "pointer",
      textAlign: "center",
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      padding: "10px",
      alignItems: "center",

      "@media (max-width: 600px)": {
        marginRight: "20px",
        fontSize: "16px",
        padding: "5px",
        alignItems: "left",
      },
    }}
  />
);
export const CustomTitle = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      marginTop: "-60px",
      color: GlobalTheme.palette.black.primary.darker,
      marginBottom: "20px",
      "@media (max-width: 375px)": {
        fontSize: "32px",
        marginTop: "70px",
        padding: "20px",
        lineHeight: 1.2,
      },
      "@media (max-width: 320px)": {
        fontSize: "32px",
        marginTop: "50px",
      },

      ...props.sx,
    }}
  />
);

export const ReviewTitle = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      marginTop: "-30px",
      color: GlobalTheme.palette.black.primary.darker,
      "@media (max-width: 375px)": {
        fontSize: "32px",
        marginTop: "70px",
        padding: "20px",
        lineHeight: 1.2,
      },
      "@media (max-width: 320px)": {
        fontSize: "32px",
        marginTop: "30px",
      },
      ...props.sx,
    }}
  />
);
export const ContactMainTitle = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      fontSize: "42px",
      marginTop: "-40px",
      color: GlobalTheme.palette.black.primary.darker,
      marginBottom: "20px",
      "@media (max-width: 375px)": {
        fontSize: "32px",
        marginTop: "20px",
        padding: "20px",
        lineHeight: 1.2,
      },
      "@media (max-width: 320px)": {
        fontSize: "32px",
        marginTop: "50px",
      },

      ...props.sx,
    }}
  />
);

export const AutorisedTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "42px",
      marginTop: "-35px",
      marginBottom: "20px",
      color: GlobalTheme.palette.black.primary.darker,
      fontWeight: GlobalTheme.typography.fontWeightBold,
      "@media (max-width: 320px)": {
        fontSize: "32px",
        marginTop: "-50px",
        marginBottom: "20px",
      },
      "@media (max-width: 425px)": {
        fontSize: "32px",
        marginTop: "-50px",
        lineHeight: 1.2,
        marginBottom: "20px",
      },
      ...props.sx,
    }}
  />
);
export const CustomTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      width: "100%",
      cursor: "pointer",
      marginLeft: "20px",
      textAlign: "left",
      color: GlobalTheme.palette.purple.primary.main,
      "@media (min-width: 640px)": {
        marginLeft: "40px",
        fontSize: "16px",
        marginBottom: "20px",
      },
      "@media (max-width: 480px)": {
        marginLeft: "40px",
        fontSize: "14px",
        marginBottom: "10px",
      },
      "@media (max-width: 320px)": {
        marginLeft: "25px",
        fontSize: "14px",
        marginBottom: "10px",
      },
    }}
  />
);

export const ContactSubHeading = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      marginBottom: "5px",
      fontSize: "20px",
    }}
  />
);

export const HeadingTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      marginTop: "7rem",
      fontSize: "42px",
      paddingBottom: "35px",
      color: GlobalTheme.palette.black.primary.darker,
      display: "flex",
      justifyContent: "center",
      fontWeight: `${GlobalTheme.typography.fontWeightLight}`,
      "@media (max-width: 320px)": {
        marginTop: "100px !important",
        marginBottom: 0,
        fontSize: `${GlobalTheme.typography.h1.fontSize}`,
      },
      ...props.sx,
    }}
  />
);

export const SubHeadingTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      display: "flex",
      justifyContent: "center",
      marginBottom: "4rem !important",
      fontSize: "26px !important",
      lineHeight: 1.5,
      color: GlobalTheme.palette.black.primary.main,
      "@media (max-width: 320px)": {
        marginTop: "-10px !important",
        marginBottom: 0,
        fontSize: `${GlobalTheme.typography.p.fontSize} !important`,
      },
    }}
  />
);

export const AuthorisedSubHeading = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      marginBottom: "60px",
      fontSize: "22px",
      padding: "10px",
      width: "90%",
      wordWrap: "break-word",
      "@media (max-width: 320px)": {
        fontSize: "18px",
        marginLeft: "10px",
        marginRight: "10px",
        marginBottom: "20px",
      },
      "@media (max-width: 375px)": {
        fontSize: "18px",
        padding: "20px",
      },
    }}
  />
);

export const TradingTitle = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      color: GlobalTheme.palette.black.primary.darker,
      marginBottom: "30px !important",
      marginTop: "-30px",
      textAlign: "center",
      "@media (max-width: 768px)": { fontSize: "32px", marginTop: "-40px" },
      "@media (max-width: 640px)": {
        fontSize: "32px",
        marginTop: "70px",
      },
      "@media (max-width: 320px)": {
        fontSize: "32px",
        marginTop: "70px",
      },
    }}
  />
);

export const ThankyouTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      marginTop: "7rem !important",
      display: "flex",
      justifyContent: "center",
      marginBottom: "1rem",
      fontSize: "42px !important",
      color: GlobalTheme.palette.black.primary.darker,
      fontWeight: `${GlobalTheme.typography.fontWeightLight}`,
    }}
  />
);

export const ThankyouSubTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      display: "flex",
      justifyContent: "center",
      marginTop: "20px !important",
      fontSize: "22px",
      color: GlobalTheme.palette.black.primary.main,
    }}
  />
);

export const PayrollTitle = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      marginTop: "4rem",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      color: GlobalTheme.palette.black.primary.main,
      marginBottom: "80px",

      "@media (max-width: 1024px)": {
        marginTop: "80px",
        lineHeight: 1.2,
        marginBottom: "60px",
      },
      "@media (max-width: 640px)": {
        fontSize: "24px !important",
        marginTop: "80px",
        lineHeight: 1.2,
        marginBottom: "60px",
      },
      "@media (max-width: 320px)": {
        fontSize: "22px !important",
        marginTop: "80px",
        padding: 0,
        lineHeight: 1.2,
        marginBottom: "60px",
      },
    }}
  />
);

// payments
export const PaymentTitle = (props) => (
  <DynamicTypography
    {...props}
    component="h1"
    sx={{
      fontSize: `${GlobalTheme.typography.h1.fontSize}`,
      marginTop: "-50px",
      color: GlobalTheme.palette.black.primary.darker,
      marginBottom: "15px",
      "@media (max-width: 320px)": {
        fontSize: "22px",
        padding: 0,
        paddingTop: 0,
        lineHeight: 1.2,
        marginBottom: "60px",
      },
      "@media (max-width: 640px)": {
        fontSize: "24px",
        marginTop: "-50px",
        lineHeight: 1.2,
      },
      "@media (max-width: 1024px)": {
        marginTop: "-50px",
        fontSize: `${GlobalTheme.typography.h1.fontSize}`,
        lineHeight: 1.2,
      },
    }}
  />
);

export const PaymentSubtitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "20px",
      color: GlobalTheme.palette.black.primary.main,
      marginBottom: "1rem !important",
      maxWidth: "600px",
    }}
  />
);

export const PaymentDescription = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "16px",
      color: GlobalTheme.palette.black.primary.main,
      marginBottom: "2rem !important",
      maxWidth: "600px",
    }}
  />
);

export const AcknowledgementTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "20px !important",
      textAlign: "left",
      width: "100%",
      fontWeight: "bold",
      marginLeft: "-15px",
      padding: "10px",
    }}
  />
);

export const AcknowledgementDescription = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      flex: 1,
      textAlign: "left",
      marginBottom: 2,
      maxWidth: "860px",
      fontSize: "14px !important",
    }}
  />
);

export const ContactTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "42px !important",
      color: GlobalTheme.palette.purple.primary.main,
      marginBottom: "30px !important",
      width: "100%",
      textAlign: "center",
    }}
  />
);

export const AddNewContactTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontWeight: "500",
      color: GlobalTheme.palette.purple.primary.main,
      marginTop: "10px !important",
      cursor: "pointer",
      marginBottom: "30px !important",
      textAlign: "center",
      width: "100%",
      marginRight: "40rem !important",
    }}
  />
);

export const NavTypography = (props) => (
  <DynamicTypography {...props} sx={{ flexGrow: 1 }} />
);

export const StyledTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "42px !important",
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "center",
      "@media (max-width: 320px)": {
        fontSize: "28px !important",
      },
    }}
  />
);

export const LoginInfoTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: GlobalTheme.typography.h1,
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "center",
      "@media (max-width: 320px)": {
        fontSize: GlobalTheme.typography.h2,
      },
    }}
  />
);

export const InfoTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: GlobalTheme.typography.h3.fontSize,
      lineHeight: GlobalTheme.typography.h3.lineHeight,
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "center",
      "@media (max-width: 320px)": {
        fontSize: "18px !important",
      },
    }}
  />
);
export const InfoItalicTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: GlobalTheme.typography.h3.fontSize,
      lineHeight: GlobalTheme.typography.h3.lineHeight,
      fontStyle: "italic",
      fontWeight: GlobalTheme.typography.fontWeightBold,
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "center",
      "@media (max-width: 320px)": {
        fontSize: GlobalTheme.typography.p,
        fontWeight: GlobalTheme.typography.fontWeightBold,
      },
    }}
  />
);

export const InfoBoldTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      marginTop: "10px",
      fontSize: GlobalTheme.typography.h3.fontSize,
      lineHeight: GlobalTheme.typography.p.lineHeight,
      fontWeight: GlobalTheme.typography.fontWeightBold,
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "center",
      "@media (max-width: 320px)": {
        fontSize: GlobalTheme.typography.p,
        fontWeight: GlobalTheme.typography.fontWeightBold,
      },
    }}
  />
);
export const EditTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.purple.primary.main,
      cursor: "pointer",
      fontWeight: "bold",
      borderRadius: "4px",
      fontSize: "20px",
      marginTop: "-20px",
    }}
  />
);

export const CardTitleTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "24px",
      marginLeft: "10px",
      marginBottom: "20px",
      fontWeight: GlobalTheme.typography.fontWeightBold,
      color: GlobalTheme.palette.black.primary.main,
    }}
  />
);

export const DynamicTitleTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "24px",
      marginLeft: "30px",
      marginBottom: "20px",
      fontWeight: GlobalTheme.typography.fontWeightBold,
      color: GlobalTheme.palette.black.primary.main,

      "@media (min-width: 375px)": {
        marginLeft: "20px",
        marginTop: "10px",
        fontSize: "16px",
        fontWeight: GlobalTheme.typography.fontWeightBold,
        order: 2,
      },

      "@media (min-width: 640px)": {
        fontSize: "24px",
        marginLeft: "20px",
        fontWeight: GlobalTheme.typography.fontWeightBold,
        order: 0,
      },

      "@media (max-width: 320px)": {
        fontSize: "16px",
        marginTop: "10px",
        marginLeft: "-1px",
        fontWeight: GlobalTheme.typography.fontWeightBold,
        order: 2,
      },
    }}
  />
);
export const CardMainTitleTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "18px",
      fontWeight: "bold",
      color: GlobalTheme.palette.grey.primary.other,
      textAlign: "left",
      marginLeft: "5px",
      "@media (max-width: 640px)": {
        fontSize: GlobalTheme.typography.p,
        fontWeight: GlobalTheme.typography.fontWeightBold,
        marginLeft: "15px",
      },
      "@media (min-width: 768px and max-width:1024px)": {
        fontSize: GlobalTheme.typography.p,
        fontWeight: GlobalTheme.typography.fontWeightBold,
        marginLeft: "25px",
      },
    }}
  />
);
export const CardInnerTitleTypography = ({ isTradingCompany, ...props }) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "18px",
      fontWeight: "bold",
      marginLeft: isTradingCompany ? "-10px" : "-30px",
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "left",
      marginTop: "10px",
    }}
  />
);
export const DataTypography = (props, index) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "left",
      marginTop: 0,
      fontSize: "20px",
      marginLeft: "30px",

      "@media (max-width: 740px)": {
        fontSize: "16px",
        marginLeft: "-10px",
      },
      "@media (max-width: 320px)": {
        fontSize: "14px",
        marginLeft: "-10px",
      },
    }}
  />
);

// ERROR
export const ErrorTypography = (props) => (
  <DynamicTypography
    variant="body1"
    {...props}
    fontWeight="500"
    color={GlobalTheme.palette.pink.primary.main}
  />
);

// DYNAMIC IMAGE UPLOAD
export const ImageDescription = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "left",
      fontSize: "16px",
      lineHeight: "20px",
    }}
  />
);

export const ImageTitleTypography = (props) => (
  <DynamicTypography
    {...props}
    variant="body1"
    sx={{
      marginTop: "10px",
      color: GlobalTheme.palette.black.primary.main,
      fontSize: "15px",
    }}
  />
);

export const LogoNameTypography = (props) => (
  <DynamicTypography
    {...props}
    variant="h5"
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      display: "flex",
      justifyContent: "left",
      fontSize: "16px",
      position: "relative",
      alignItems: "center",
    }}
  />
);

export const ImageTypography = (props, index) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.darker,
      textAlign: "left",
      fontSize: "18px",
    }}
  />
);

export const SupportFormatTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      textAlign: "left",
      fontSize: "16px",
      fontStyle: "italic",
    }}
  />
);

export const AustorisedTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.darker,
      fontWeight: GlobalTheme.typography.fontWeightMedium,
      marginBottom: "40px",
      marginTop: "20px",
      fontSize: "24px",
      textAlign: "left",
      "@media (max-width: 320px)": {
        fontSize: "18px",
        marginLeft: "-10px",
      },
      "@media (max-width: 740px)": {
        fontSize: "20px",
        marginLeft: "-10px",
      },
    }}
  />
);
export const ContactTypeTypography = (props) => (
  <DynamicTypography
    {...props}
    color={GlobalTheme.palette.black.primary.main}
    marginBottom={3}
    display="flex"
    alignItems="left"
    variant="body1"
    sx={{
      fontSize: "20px",
      marginLeft: "-20px",
    }}
  />
);
export const ReviewContactTitleTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "18px",
      fontWeight: "bold",
      color: GlobalTheme.palette.black.primary.main,
      marginBottom: "10px",
    }}
  />
);

export const ReviewContactEditTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.purple.primary.main,
      cursor: "pointer",
      fontWeight: "bold",
      padding: "8px 16px",
      borderRadius: "4px",
    }}
  />
);

export const ReviewContactKeyTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.grey.primary.other,
      fontWeight: "bold",
      marginBottom: "4px",
      textAlign: "left",
      marginLeft: "15px",
    }}
  />
);

export const ReviewContactValueTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.darker,
      textAlign: "left",
      marginLeft: "15px",
    }}
  />
);

export const DynamicSectionDetails = ({ isTradingCompany, ...props }) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      marginLeft: isTradingCompany ? "-10px" : "-30px",
    }}
  />
);

export const NoImageTypography = (props) => (
  <DynamicTypography
    variant="body1"
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      fontSize: "18px",
    }}
  />
);

export const PaymentAcknowledgementTypography = (props) => (
  <DynamicTypography
    variant="body1"
    {...props}
    sx={{
      flex: 1,
      marginBottom: 2,
      maxWidth: "860px",
      marginRight: 0,
      textAlign: "left",
      order: 0,
    }}
  />
);

export const ImageTypeTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "30px",
      textAlign: "left",
      marginLeft: "-1px",

      color: GlobalTheme.palette.grey.primary.other,
    }}
  />
);

export const PostalDisableTypography = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      cursor: "pointer",
      textAlign: "left",
      width: "100%",
      color: GlobalTheme.palette.purple.primary.main,
      marginLeft: "25px",
      "@media (max-width: 640px )": {
        marginLeft: "40px",
        fontSize: "14px",
        marginBottom: "20px",
      },
      "@media (max-width: 320px)": {
        marginLeft: "25px",
        fontSize: "14px",
      },
    }}
  />
);

export const VerificationHeading = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      fontSize: `${GlobalTheme.typography.h1.fontSize} !important`,
      lineHeight: "33px",
      "@media (max-width: 640px)": {
        fontSize: GlobalTheme.typography.h3.fontSize,
        lineHeight: GlobalTheme.typography.h3.lineHeight,
      },
    }}
  />
);

export const VerificationSubHeading = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      fontSize: GlobalTheme.typography.h3.fontSize,
      lineHeight: "21px",
      "@media (max-width: 640px)": {
        fontSize: GlobalTheme.typography.p.fontSize,
        lineHeight: GlobalTheme.typography.p.lineHeight,
      },
    }}
  />
);

export const TermsConditionDescription = (props) => (
  <DynamicTypography
    {...props}
    variant="body1"
    sx={{
      // marginTop: "30px",
      flex: 1,
      textAlign: "left",
      order: 0,
      lineHeight: 1.5,
      padding: "40px",
      fontWeight: GlobalTheme.typography.fontWeightRegular,
      fontSize: GlobalTheme.typography.h3.fontSize,
      color: GlobalTheme.palette.black.primary.main,
      "@media (max-width: 320px)": {
        fontSize: "18px",
        padding: "15px",
        paddingTop: 0,
        marginTop: "30px",
      },
      "@media (max-width: 740px)": {
        fontSize: "18px",
        padding: "20px",
        paddingTop: 0,
        marginTop: "30px",
      },
    }}
  />
);

export const TradingDialogTitle = (props) => (
  <DynamicTypography
    {...props}
    sx={{
      color: GlobalTheme.palette.black.primary.main,
      fontWeight: GlobalTheme.typography.fontWeightLight,
      fontSize: "28px",
      padding: "20px",
      textAlign: "left",
      "@media (max-width: 320px)": {
        fontSize: "22px",
        padding: "10px",
        paddingTop: 0,
        marginTop: "30px",
        marginLeft: "-20px",
      },
      "@media (max-width: 740px)": {
        fontSize: "22px",
        padding: "10px",
        paddingTop: 0,
        marginTop: "30px",
        marginLeft: "-20px",
      },
    }}
  />
);

export const TradingDropdown = (props) => (
  <DynamicTypography
    {...props}
    variant="body2"
    color="textSecondary"
    align="right"
    paddingRight={1}
  />
);

export const HelperTextTypography = (props) => (
  <DynamicTypography
    {...props}
    variant="body2"
    sx={{
      color: `${GlobalTheme.palette.pink.primary.main} `,
      textAlign: "right",
      marginRight: "auto",
      marginLeft: 1,
      marginBottom: "1px",
      fontSize: "12px",
    }}
  />
);
